<div class="postcard-container">
  <div class="postcard-left">
    <p>
      Hei du,
      <br />
      diese Webseite hat einen kleinen emotionalen Wert für mich. Die
      Schneiderei hat früher meiner Oma gehört. Nach ihrem Tod wurde die Schneiderei von ihrer Mitarbeiterin übernommen. Der Name hat sich zwar von "Annelies Atelier"
      auf "Schneiderei Petra Dollinger" geändert, aber das Logo ist noch von
      meiner Oma.
    </p>
  </div>
  <div class="postcard-right">
    <div class="img-container">
      <img
        src="../../../../../assets/projects/schneidereipd/stamp.webp"
        height="80"
      />
    </div>
    <div class="address">
      <div>
        <h5>Schneiderei Petra Dollinger</h5>
        <div class="data-row">
          <p>Dauer</p>
          <p>3 Monate</p>
        </div>
        <div class="data-row">
          <p>Technologie</p>
          <p>Angular</p>
        </div>
        <div class="data-row">
          <p>Website</p>
          <p>
            <a
              class="accent"
              href="https://www.schneidereipd.de"
              target="_blank"
              >Schneidereipd.de</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
